import DuckEntity from './DuckEntity';

const entity = new DuckEntity('tags');
const reducer = entity.reducer
export {reducer as default, entity};
